import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { ProgressBar } from "primereact/progressbar";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Calendar } from "primereact/calendar";
import { useNavigate } from "react-router-dom";

const FormBusquedaProductos = ({
  baseUrl,
  cliente,
  empresa,
  setEmpresa,
  tipoProducto,
  setTipoProducto,
  tiposProducto,
  setTiposProducto,
  desde,
  setDesde,
  hasta,
  setHasta,
  searchProductos,
  idCotizacion,
}) => {
  const today = new Date();
  const navigate = useNavigate();
  const [tipoProductoTouched, setTipoProductoTouched] = useState(false);

  // Empresas disponibles
  const empresasOptions = [
    { label: 'ALTAMIRA', value: 'ALTAMIRA' },
    { label: 'LA SIEMBRA', value: 'LA SIEMBRA' },
    { label: 'TODAS', value: 'TODAS' }
  ];

  const fetchData = async (url) => {
    const response = await fetch(url, {
      method: "GET",
      headers: new Headers(),
      redirect: "follow",
      credentials: "include", 
    });

    if (!response.ok) {
      throw new Error(`Network response was not ok. Status: ${response.status}`);
    }

    return response.json();
  };

  const getTipoProductoByEmpresa = async (empresa) => {
    try {
      const url = `${baseUrl}getTiposProductoByEmpresa?empresa=${empresa}`;
      const data = await fetchData(url);
      if (Array.isArray(data.tiposProductos)) {
        setTiposProducto(data.tiposProductos);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getEmpresaByCotizacion = async (idCotizacion) => {
    try {
      const url = `${baseUrl}getCotizacionById?idCotizacion=${idCotizacion}`;
      const data = await fetchData(url);
      const empresaCotizacion = data.cotizacion.empresa;
      
      // Verificar si la empresa existe en las opciones
      const empresaExiste = empresasOptions.find(emp => emp.value === empresaCotizacion);
      
      if (empresaExiste) {
        setEmpresa(empresaCotizacion);
        await getTipoProductoByEmpresa(empresaCotizacion);
      } else {
        // Si no existe, usar TODAS como fallback
        setEmpresa('TODAS');
        await getTipoProductoByEmpresa('TODAS');
      }
    } catch (error) {
      console.error("Error en getEmpresaByCotizacion:", error);
    }
  };

  // Cargar tipos de producto iniciales
  useEffect(() => {
    getTipoProductoByEmpresa("TODAS");
  }, []);

  // Cargar empresa por cotización (solo una vez)
  useEffect(() => {
    if (idCotizacion) {
      getEmpresaByCotizacion(idCotizacion);
    }
  }, [idCotizacion]);

  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const tomorrowHasta = new Date(today);
  tomorrowHasta.setDate(tomorrowHasta.getDate() + 2);

  return (
    <>
      <Button 
        label="Volver a Cotizaciones" 
        icon="pi pi-arrow-left" 
        rounded 
        outlined 
        onClick={() => {
          navigate("/cotizacion", { state: { isFormVisible: false } });
        }} 
      />
      <ProgressBar value="100" showValue={false} className="mt-2 mb-4" />
      
      <div className="p-fluid formgrid grid" id="clienteSeleccionado">
        <div className="field col-12 md:col-2">
          <h5 style={{ color: "green" }}>Cliente Seleccionado</h5>
        </div>
        <div className="field col-12 md:col-2">
          <label>RUT</label>
          <h6>{cliente.rut}</h6>
        </div>
        <div className="field col-12 md:col-2">
          <label>Razón Social</label>
          <h6>{cliente.razon_social}</h6>
        </div>
        <div className="field col-12 md:col-2">
          <label>Nombre Fantasia</label>
          <h6>{cliente.nombre_fantasia}</h6>
        </div>
        <div className="field col-12 md:col-2">
          <label>alias</label>
          <h6>{cliente.alias}</h6>
        </div>

      </div>
      
      <ProgressBar value="100" showValue={false} className="mt-2 mb-4" />
      
      <h4 style={{ marginBottom: "5px" }}>
        Cree la nueva asignación de servicios para la cotizacion # {idCotizacion}
      </h4>
      <h6 style={{ marginTop: "5px" }}>
        Seleccione empresa, tipo de producto y rango de fechas
      </h6>
      
      <div className="p-fluid formgrid grid" style={{ marginTop: "20px" }}>
        {/* Dropdown de empresa */}
        <div className="field col-12 md:col-6">
          <label>Empresa *</label>
          <Dropdown
            value={empresa}
            options={empresasOptions}
            onChange={async (e) => {
              setEmpresa(e.value);
              setTipoProducto("");
              await getTipoProductoByEmpresa(e.value);
            }}
            placeholder="Seleccione Empresa"
          />
        </div>

        {/* MultiSelect tipo producto */}
        <div className="field col-12 md:col-6">
          <label>Tipo Producto *</label>
          <MultiSelect
            value={tipoProducto}
            onChange={(e) => {
              setTipoProducto(e.value);
              setTipoProductoTouched(true);
            }}
            onBlur={() => setTipoProductoTouched(true)}
            options={tiposProducto
              .filter((option, index, self) =>
                index === self.findIndex((t) => t.descripcion === option.descripcion)
              )
              .map((option) => ({
                ...option,
                label: option.descripcion,
              }))
            }
            optionLabel="label"
            placeholder="Seleccione Tipo Producto"
            filter
            required
            className={tipoProductoTouched && (!tipoProducto || tipoProducto.length === 0) ? 'p-invalid' : ''}
          />
          {tipoProductoTouched && (!tipoProducto || tipoProducto.length === 0) && (
            <small className="p-error">El tipo de producto es obligatorio</small>
          )}
        </div>

        {/* Fecha Desde */}
        <div className="field col-12 md:col-6">
          <label>Fecha de inicio *</label>
          <Calendar
            dateFormat="dd/mm/yy"
            showIcon
            showButtonBar
            value={desde}
            onChange={(e) => setDesde(e.value)}
            minDate={tomorrow}
            placeholder="Seleccione una fecha"
          />
        </div>

        {/* Fecha Hasta */}
        <div className="field col-12 md:col-6">
          <label>Fecha de termino *</label>
          <Calendar
            dateFormat="dd/mm/yy"
            showIcon
            showButtonBar
            value={hasta}
            onChange={(e) => setHasta(e.value)}
            minDate={tomorrowHasta}
            placeholder="Seleccione una fecha"
          />
        </div>

        {/* Botón buscar productos */}
        <div className="field col-12 md:col-12" style={{ display: "flex", justifyContent: "center" }}>
          <Button
            label="Buscar Productos"
            icon="pi pi-search"
            className="mr-2 mb-2 p-button-rounded"
            onClick={searchProductos}
            style={{ width: "400px" }}
          />
        </div>
      </div>
    </>
  );
};

export default FormBusquedaProductos;
